/**
 *
 * Asynchronously loads the component for ItemOverviewTable
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ItemOverviewTable = lazyLoad(
  () => import('./index'),
  module => module.ItemOverviewTable,
);
